module.exports = __webpack_public_path__ + "img/order-Y.0f278475.png";